import api from "./api";
import {
  WABroadcastCreate,
  WABroadcastPreviewPayload,
  WASendTemplatePayload,
} from "../types/whatsapp-broadcast";

// --- Templates ---
export const listTemplates = async () => {
  const res = await api.get("wa/templates");
  return res.data;
};

export const syncTemplates = async () => {
  const res = await api.post("wa/templates/sync");
  return res.data;
};

export const createTemplate = async (body: any) => {
  const res = await api.post("wa/templates", body);
  return res.data;
};

export const updateTemplate = async (id: string, body: any) => {
  const res = await api.put(`wa/templates/${id}`, body);
  return res.data;
};

export const deleteTemplate = async (id: string) => {
  const res = await api.delete(`wa/templates/${id}`);
  return res.data;
};

export const setTemplateEnabled = async (id: string, enabled: boolean) => {
  const res = await api.put(`wa/templates/${id}/enabled`, { enabled });
  return res.data;
};

// --- Broadcasts ---
export const previewBroadcast = async (payload: WABroadcastPreviewPayload) => {
  const res = await api.post("wa/broadcasts/preview", payload);
  return res.data;
};

export const createBroadcast = async (body: WABroadcastCreate) => {
  const res = await api.post("wa/broadcasts", body);
  return res.data;
};

export const listBroadcasts = async () => {
  const res = await api.get("wa/broadcasts");
  return res.data;
};

export const getBroadcast = async (id: string) => {
  const res = await api.get(`wa/broadcasts/${id}`);
  return res.data;
};

export const retryBroadcast = async (id: string) => {
  const res = await api.post(`wa/broadcasts/${id}/retry`);
  return res.data;
};

// --- Inbox ---
export const sendTemplate = async (
  convId: string,
  payload: WASendTemplatePayload,
) => {
  const res = await api.post(`wa/conversations/${convId}/send-template`, payload);
  return res.data;
};

// Re-export for convenience (image upload for broadcast/template header is
// the same endpoint as inbox media upload — see whatsappService.ts).
export { uploadImage } from "./whatsappService";

// --- Settings (management token / WABA ID) ---
export const getWASettings = async () => {
  const res = await api.get("wa/settings");
  return res.data;
};

export const updateWASettings = async (body: { mgmt_token?: string; waba_id?: string }) => {
  const res = await api.put("wa/settings", body);
  return res.data;
};

export const testWAToken = async () => {
  const res = await api.post("wa/settings/test");
  return res.data;
};
